<template>
    <div class="mt-4" style="min-height: 80vh">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <loading
          :active="loading"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>

      <div class="text-left">
        <p style="font-weight: 700; color: #0069A9;">Diágnostico inicial del OG</p>

        <v-select style="width: 30%"
                  v-model="ptiSeleccionado"
                  :options="lstPtis"
                  :reduce="(variable) => variable.idPti"
                  label="idPti"
                  placeholder="Selecciona el PTI a consultar"
                  @input="obtenerDatosDiagnostico"
                  :clearable="false">
          <template #option="{ fechaAlta, registroActivo }">
            <li>
              PTI del {{ fechaAlta | formatoFecha }}&nbsp;
              <span :style="registroActivo ? 'color: #88D487' : 'color: #E0E0E0'">{{ registroActivo ? '(activo)' : '(inactivo)' }}</span>
            </li>
          </template>
          <template #selected-option="{ fechaAlta, registroActivo }">
            <div style="display: flex; align-items: baseline">
              PTI del {{ fechaAlta | formatoFecha }}
              <span :style="registroActivo ? 'color: #88D487' : 'color: #E0E0E0'">{{ registroActivo ? '(activo)' : '(inactivo)' }}</span>
            </div>
          </template>
          <template #no-options>
            No se encontró información. Recuerda que solo se tienen datos a partir de Noviembre 2024
          </template>
        </v-select>

        <div v-show="ptiSeleccionado !== null" class="mt-4" style="font-size: .85em;">
          <p class="m-1"><span class="fontBold">Motivo de cita: </span>{{ obtenerDescTagMotivoCita() }}</p>
          <p class="m-1" v-if="!segundaOpcionCreada"><span class="fontBold">Nivel PTI: </span>{{ diagnostico.nivelPti }}</p>
          <p class="m-1" v-if="segundaOpcionCreada"><span class="fontBold">Nivel más alto de PTI entre las opciones: </span>{{ diagnostico.nivelPti }}</p>
          <p class="m-1"><span class="fontBold">OG: </span>{{diagnostico.empleado}}</p>
          <p class="m-1"><span class="fontBold">Clínica: </span>{{ diagnostico.clinica }}</p>
        </div>
      </div>
      
      <b-row v-show="ptiSeleccionado !== null" class="mt-2">
        <b-col cols="3">
          <odontograma
              :disable="true"
              :dientesSeleccionados="dientesSeleccionados"
              :multiplesDientesSeleccionados="[]"/>
        </b-col>
        <b-col>
          <div class="d-flex justify-content-end">
            <herramientasModal class="mr-4" :idPacienteExp="paciente.idPaciente" :diagInicial="diagInicial"></herramientasModal>
            <observacionesCita ref="obserCita" :idCita="idCitaPaciente" :diagInicial="diagInicial"></observacionesCita>
          </div>
          <p class="text-left mt-2 mb-0" style="font-weight: 500; color: #53BACA; margin-left: -4%;">Padecimientos detectados</p>
          <div class="d-flex justify-content-end">
            <div class="d-flex justify-content-between" style="width: 15%;">
              <em class="boton_ordenar_categoria" v-b-tooltip.hover.v-light.topright="'Ordenar por categoría'" @click="ordenarCategoria()"></em>
              <em v-if="!activo" class="boton_mostrar_todo" v-b-tooltip.hover.v-light.topright="'Desplegar todo'" @click="desplegar()"></em>
              <em v-else class="boton_ocultar_todo" v-b-tooltip.hover.v-light.topright="'Contraer todo'" @click="ocultar()"></em>
              <em class="boton_ordenar_od" v-b-tooltip.hover.v-light.topright="'Ordenar ODs'" @click="ordenarODS()"></em>
            </div>
          </div>

          <div class="mt-3 d-flex" v-for="(diente,i) in diagnostico.dientes" :key="diente.diente.diente" style="margin-left: -4%;">
            <div class=" text-left">
              <em v-if=" diente.padecimiento != null ? diente.padecimiento.idClasificacionClinica == 1 : false"
                class="fa fa-star mt-1" style="font-size: x-large; color: #FFC300;" 
                v-b-tooltip.hover.v-light.topright="'Este registro es prioridad clínica'"></em>
              <div v-else class="ml-4"></div>
            </div>
  
            <div class=" w-100" style="">

              <HDPadecimientosViewOnly
              :diente="diente"
              :segundaOpcionCreada="segundaOpcionCreada"
              :segundaOpcionSeleccionada="segundaOpcionSeleccionada"
              :index="i"
              :obtenerSugerencias="obtenerSugerencias"></HDPadecimientosViewOnly>

            </div>
          </div>
        </b-col>
      </b-row>
        
    </div>
  </template>
  
  <script>
  import herramientasModal from "@/version5/herramientas/componentes/HerramientasModal";
  import observacionesCita from "@/version5/cita/componentes/ObservacionesCita";
  import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
  import HDPadecimientosViewOnly from "../../../version5/diagnostico/HDPadecimientosViewOnly.vue"
  import Odontograma from "@/version5/diagnostico/NuevoOdontograma.vue";
  export default {
    name: "DiagnosticoInicialPTI",
    props: {
      paciente: Object,
      idCita: Number,
      contraerCard: Boolean,
    },
    components:{
      Odontograma,
      observacionesCita,
      herramientasModal,
      HDPadecimientosViewOnly
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loading: false,
      ptiPrsuntivoServicio: new PtiPresuntivoService(),
      activo: false,
      catTratamientos: [],
      listaKits: [],
      disable: false,
      id_denticion: null,
      segundaOpcionSeleccionada: 0,
      multiTrt: false,
      modificar: false,
      ordenarOds: false,
      obtenerSugerencias: false,
      dientesSeleccionados: [],
      idSesionSeleccionada: null,
      idCitaPaciente: null,
      idTagMotivoCita: null,
      diagInicial: true,
      diagnostico: {
        dientes: []
      },
      tagmotivocitaDatosArrayOriginal: [],
      lstPtis: [],
      ptiSeleccionado: null
    }),
    computed: {
      segundaOpcionCreada() {
        return this.diagnostico.dientes.some(d => {
          if (d.tratamientos[1] !== null && d.tratamientos[1] !== undefined) {
            return d.tratamientos[1].length > 0
          } else {
            return false;
          }
        });
      }
    },
    created(){
      this.debug = this.$localStorageService.getDebug();
      this.traerDiagnosticoInicialPtis()
      this.tagMotivoCita()
    },
    methods: {
      dienteSeleccionado(data) {
                this.diente = data.diente;

                this.dientesSeleccionados = data.dientes;
                if (data.diente.idDiente != 137) {
                    const i = this.formulario.dientes.map(d => d.diente.idDiente).indexOf(this.diente.idDiente)
                    if (i > -1) {
                        this.$swal.fire({
                            icon: "error",
                            title: "<span style='font-size: medium'>upps, no se puede agregar otro \n padecimiento a este diente</span>",
                            text: "pero no te preocupes, intenta con otro diente",
                            customClass: {
                                confirmButton: "text-small",
                                content: "text-small",
                            }
                        });
                        return;
                    }
                }
                this.formulario.dientes.unshift({
                    diente: this.diente,
                    buscar: true,
                    seleccionar: false,
                    visible: false,
                    padecimiento: null,
                    tratamientos: [],
                    visiblePadecimiento: false
                });
            },
      obtenerDatosDiagnostico(){
        this.loading = true;
        this.$refs.obserCita.mostrarInformacion = false;
        const data = {
          idPti: this.ptiSeleccionado
        }
        this.$http.post(this.$api + "ptipresuntivo/obtener/hdx/inicial-og",data)
        .then(async (respuesta) => {
            if (respuesta.data.data) {
              this.diagnostico = respuesta.data.data;
              this.idTagMotivoCita = respuesta.data.data.idTagMotivoCita;
              this.dientesSeleccionados = this.diagnostico.dientes.map(d => d.diente);
              this.idSesionSeleccionada = respuesta.data.data.idSesion;
            }
 
          }).catch((error)=> {
            console.log(error);
          })
          .finally(() => {
            this.obtenerCita();
            this.loading = false;
          }); 
      },

      ordenarCategoria(){
        let prioridad = this.diagnostico.dientes.filter(item=>{
          return item.padecimiento.idClasificacionClinica == 1;
        })

        let hallazgo = this.diagnostico.dientes.filter(item=>{
          return item.padecimiento.idClasificacionClinica == 2;
        })

        let sinClasificacion = this.diagnostico.dientes.filter(item=>{
          return item.padecimiento.idClasificacionClinica == null;
        })

        this.diagnostico.dientes = []
        prioridad.forEach(element => {
          this.diagnostico.dientes.push(element);
        });

        hallazgo.forEach(element => {
          this.diagnostico.dientes.push(element);
        });

        sinClasificacion.forEach(element => {
          this.diagnostico.dientes.push(element);
        });
      },

      desplegar() {
        this.diagnostico.dientes.forEach(diente => {
          if (diente.padecimiento != null) {
            diente.visible = true;
          }
        })
        this.activo = true            
      },

      ocultar() {
        this.diagnostico.dientes.forEach(diente => {
          if (diente.padecimiento != null) {
            diente.visible = false;
          }
        })
        this.activo = false
      },

      obtenerCita(){
        const params = {
          idSesion: this.idSesionSeleccionada
        };
        this.$http.post(this.$api + "version5/ptipresuntivo/obtenerCita", params).then((response) => {
           this.idCitaPaciente = response.data.data;
        })
      },
      tagMotivoCita() {
        this.tagmotivocitaDatosArrayOriginal = [];

        this.$http
            .get(
                this.$api +
                "tagmotivocita/tagmotivocita"
            )
            .then((response) => {
              this.tagmotivocitaDatosArrayOriginal = response.data.data
            })
            .finally(() => {
            });
      },
      obtenerDescTagMotivoCita() {
        if (this.tagmotivocitaDatosArrayOriginal != undefined && this.tagmotivocitaDatosArrayOriginal != null) {
          const tagEncontrado = this.tagmotivocitaDatosArrayOriginal.find(it =>
              it.idTagMotivoCita === this.idTagMotivoCita);

          if (tagEncontrado != undefined && tagEncontrado != null) {
            return tagEncontrado.descripcionTagMotivoCita;
          }
        }
        return "";
      },
      ordenarODS(){
        this.ordenarOds = true;
        let dientesOrdenados = [];
        // dar orden a boca completa
        this.diagnostico.dientes.forEach(d => {
          d.cambio = false;
          if(d.diente.idDiente == 59){
            if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 179
                && d.padecimiento.idPadecimiento != 74 && d.padecimiento.idPadecimiento != 73)){
              d.diente.orden = 33
            } else if(d.padecimiento.idPadecimiento == 73){
              d.diente.orden = 34
            } else if(d.padecimiento.idPadecimiento == 74){
              d.diente.orden = 35
            } else if(d.padecimiento.idPadecimiento == 179){
              d.diente.orden = 36
            }
          }
          // dar orden a superior
          if(d.diente.idDiente == 57){
            if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 165
                && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 49
                && d.padecimiento.idPadecimiento != 10)){
              d.diente.orden = 37
            } else if(d.padecimiento.idPadecimiento == 10){
              d.diente.orden = 38
            } else if(d.padecimiento.idPadecimiento == 49){
              d.diente.orden = 39
            } else if(d.padecimiento.idPadecimiento == 162){
              d.diente.orden = 40
            } else if(d.padecimiento.idPadecimiento == 165){
              d.diente.orden = 41
            }
          }
          // dar orden a inferior
          if(d.diente.idDiente == 58){
            if(d.padecimiento == null || (d.padecimiento.idPadecimiento != 49
                && d.padecimiento.idPadecimiento != 162 && d.padecimiento.idPadecimiento != 165)){
              d.diente.orden = 42
            } else if(d.padecimiento.idPadecimiento == 49){
              d.diente.orden = 43
            } else if(d.padecimiento.idPadecimiento == 162){
              d.diente.orden = 44
            } else if(d.padecimiento.idPadecimiento == 165){
              d.diente.orden = 45
            }
          }
        });
        dientesOrdenados = this.diagnostico.dientes
        let dientes = dientesOrdenados.map(dior => dior.diente.orden);
        var length = dientes.length;
        for (var i = 0; i < length; i++) {
          for (var j = 0; j < (length - i - 1); j++) {
            if(dientes[j] > dientes[j+1]) {
              var tmp = dientes[j];
              dientes[j] = dientes[j+1];
              dientes[j+1] = tmp;
            }
          }
        }
        this.load = true;
        this.diagnostico.dientes = [];
        setTimeout(() => {
          for (let i = 0; i < dientes.length; i++) {
            this.diagnostico.dientes.push(dientesOrdenados[dientesOrdenados.findIndex(d => d.diente.orden == dientes[i])]);
          }
          this.load = false;
        }, 500);
        this.load = false;
      },
      traerDiagnosticoInicialPtis() {
        const params = {
          idPaciente: this.paciente.idPaciente
        }
        this.$http
            .post(this.$api + "ptipresuntivo/obtener/ptis/inicial-og/paciente", params)
            .then((response) => {
              this.lstPtis = response.data.data;
            })
            .catch((error) => {
              console.error(error);
            })

      }
    },
  }
  </script>
  
  <style scoped>
    .fontBold{
      font-weight: 600;
    }
  </style>
  